module.exports = __webpack_public_path__ + "img/hospital14.79e7868a.png";